import React, { useState } from 'react';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import Bouton from '../../UI/Bouton/Bouton';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import styles from './ImporterCapteurCSV.module.scss';

const ImporterCapteurCSV = ({
  reqAjouter,
  reqModifier,
  reqImportationCapteursEnLot,
}) => {
  const [fileState, setFileState] = useState({
    apercus: '',
    configuration: null,
    configurationSimpleBool: true,
    creerSimple: true,
  });

  const telechagementCSV = (evt) => {
    const fileObj = evt.target.files[0];
    const reader = new FileReader();

    const fileloaded = (e) => {
      const fileContents = e.target.result;
      const first80char = fileContents.substring(0, 80);

      try {
        const configurationCapteur = JSON.parse(fileContents);

        // Update all state at once to avoid multiple re-renders
        setFileState((prevState) => ({
          ...prevState,
          apercus:
            'First 80 characters of the file:\n' + first80char + '       ...',
          configuration: configurationCapteur,
          configurationSimpleBool: !configurationCapteur.sensors_list?.length,
          creerSimple:
            !configurationCapteur.sensors_list?.length &&
            !configurationCapteur.sensor_id,
        }));
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    };

    reader.onload = fileloaded;
    reader.readAsText(fileObj);
  };

  const renderImportButton = () => {
    if (!fileState.configuration) return null;

    if (fileState.configurationSimpleBool) {
      if (fileState.creerSimple) {
        return (
          <AttenteRequete
            request_type={requestType.creation_d_un_capteur}
            str={checkMot('importation_en_cour')}
          >
            <Bouton cliquer={() => reqAjouter(fileState.configuration)}>
              {checkMot('importer_configuration_creation_capteur')}
            </Bouton>
          </AttenteRequete>
        );
      }

      return (
        <AttenteRequete
          request_type={requestType.modification_d_un_capteur}
          str={checkMot('importation_en_cour')}
        >
          <Bouton cliquer={() => reqModifier(fileState.configuration)}>
            {checkMot('importer_configuration_modification_capteur')}
          </Bouton>
        </AttenteRequete>
      );
    }

    return (
      <AttenteRequete
        request_type={requestType.importation_des_capteurs_en_lot}
        str={checkMot('importation_en_cour')}
      >
        <Bouton
          cliquer={() => reqImportationCapteursEnLot(fileState.configuration)}
        >
          {checkMot('importer_liste_configurations_capteur')}
        </Bouton>
      </AttenteRequete>
    );
  };

  return (
    <>
      <label htmlFor="avatar" className={styles.label}>
        {checkMot('choisir_fichier_configuration')}
      </label>
      <input
        type="file"
        id="avatar"
        onChange={telechagementCSV}
        accept=".json"
      />
      <div className={styles.Apercus}>{fileState.apercus}</div>
      {renderImportButton()}
    </>
  );
};

export default ImporterCapteurCSV;
